var $093d57e325bc9071$exports = {};
$093d57e325bc9071$exports = {
  "removeButtonLabel": "Elt\xE1vol\xEDt\xE1s",
  "removeDescription": "Nyomja meg a Delete billenty\u0171t a c\xEDmke elt\xE1vol\xEDt\xE1s\xE1hoz."
};
export { $093d57e325bc9071$exports as default };